// pc端
    function playYoutubeVideo(url,flag){

        var videoHtml = '<iframe width="100%" height="100%" src="' + url + '" class="youtube-player youtubeVideo" frameborder="0"></iframe>';

        $("#videoIframe"+flag).prepend(videoHtml);
        $("#show-video-"+flag).show();
    }

    $(".video-close").click(function() {
        $("#show-video-{{ section.settings.flag }}").hide();
        $(".youtubeVideo").remove();
    })

    // 移动端
    function playYoutubeVideoMobile(url,flag){

        var videoHtml = '<iframe width="100%" height="100%" src="' + url + '" class="youtube-player youtubeVideo" frameborder="0"></iframe>';

        $("#videoIframe_mobile"+flag).prepend(videoHtml);
        $("#show-video-mobile-"+flag).show();
    }

    $(".video-close").click(function() {
        $("#show-video-mobile-{{ section.settings.flag }}").hide();
        $(".youtubeVideo").remove();
    })